import React from "react";
import { useState } from "react";
import { useQueryClient } from "react-query";
import QuillTextEditor from "../../../../../components/textEditor/Quill-Text-Editor";
import DoubleClickEdit from "../../../../../components/DoubleClickEdit";
import DisplayTaskRichText from "./DisplayTaskRichText";

/**
 * Inline double-click-editable task content editor.
 * Displays the task's rich text via DisplayTaskRichText in read mode.
 * Double-clicking (or mounting with `startInEditMode`) switches to a
 * Quill editor that saves directly to the `client_tasks` document endpoint.
 * Legacy tasks without `task.content` are shown as a non-editable notice.
 *
 * @param {object}  props
 * @param {object}  props.task                    - Task object with `task_id` and `content` (Quill delta)
 * @param {string}  props.listQueryKey            - React-Query key invalidated after save
 * @param {boolean} [props.startInEditMode=false] - Opens the editor immediately on mount
 */
const TaskContent = ({ task, listQueryKey, startInEditMode = false }) => {
    const [showEdit, setShowEdit] = useState(startInEditMode);
    const handleSave = () => {
        queryClient.invalidateQueries(listQueryKey);
        setShowEdit(false);
    };
    const options = {
        is_draft: false,
        route: "client_tasks",
        search_params: { document_id: task.task_id },
    };

    const queryKey = `${task.task_id}`;
    const queryClient = useQueryClient();

    return (
        <DoubleClickEdit
            showEdit={showEdit}
            setShowEdit={setShowEdit}
            defaultComponent={<DisplayTaskRichText task={task} isTruncated={false} />}
            editComponent={
                <div className="w-full">
                    {task.content ? (
                        <QuillTextEditor
                            placeholder="Create New Note"
                            options={options}
                            queryKey={queryKey}
                            listQueryKey={listQueryKey}
                            autoFocus={startInEditMode}
                        />
                    ) : (
                        <>
                            {/* <MarkdownNotes noteRaw={task.description} /> */}
                            <p>Can't edit old note editor tasks</p>
                        </>
                    )}
                </div>
            }
            handleSubmitEdit={handleSave}
            componentName="description"
        />
    );
};

export default TaskContent; 